import { FlowCompleteEvent, IFlow } from "./types";

export class GameStateController {
  private currentFlow: IFlow<unknown> | undefined = undefined;
  private flowStack: IFlow<unknown>[] = [];

  public constructor() {}

  CancelCurrentFlow(): void {
    this.currentFlow?.Cancel();
  }

  setNextFlow(flow: IFlow<unknown>): void {
    console.log("Starting flow " + flow.name());
    if (this.currentFlow != undefined) {
      this.flowStack.push(this.currentFlow);
      console.log("Suspending " + this.currentFlow.name());
      this.currentFlow.Suspended();
    }
    this.currentFlow = flow;
    this.currentFlow.onComplete(this.flowComplete.bind(this));
    void this.currentFlow.Execute();
  }

  private flowComplete(evt: FlowCompleteEvent<unknown>): void {
    const completedFlow = evt.flow;
    if (completedFlow.name() != this.currentFlow!.name()) {
      throw new Error(
        "Only currentFlow can complete. flow=" +
          completedFlow.name() +
          " currentFlow=" +
          this.currentFlow!.name(),
      );
    }
    this.currentFlow = this.flowStack.pop();
    console.log("Restoring " + this.currentFlow?.name());
    if (this.currentFlow)
      // In next frame
      setTimeout(
        () => this.currentFlow && this.currentFlow.Restored(new Event('flow-restored')),
        0,
      );
    else console.log("FlowStack is empty! Last flow was ", completedFlow);
  }
}
